function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "34",
  height: "25",
  viewBox: "0 0 34 25",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Meldedialog",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Meldung-1b",
  transform: "translate(-168 -296)",
  stroke: "#0F0F0F",
  strokeWidth: "4.8"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path-15",
  d: "M169.656 308.741l10.221 8.57 20.001-19.006"
})))));